// extracted by mini-css-extract-plugin
module.exports = {"mapHeader":"MapHeader_mapHeader__Xd8Ge","mapHeaderNoItems":"MapHeader_mapHeaderNoItems__WURCP","windStations":"MapHeader_windStations__jPHDg","buoys":"MapHeader_buoys__wzooT"};